export enum Combinator {
  AND = 'and',
  OR = 'or',
}
